<template>
  <notice-list :is-admin="true"></notice-list>
</template>

<script>

import NoticeList from '@/components/NoticeList'

export default {
  name: 'AdminListNotices',
  components: {
    NoticeList,
  },
}
</script>
